import { useNavigate } from 'react-router-dom';
import { hapticFeedback } from '@telegram-apps/sdk';
import { MemberStatsSection, TransferredList, CompletedList } from '../components/stats';
import './StatsPage.css';

export function StatsPage() {
  const navigate = useNavigate();

  const handleReportClick = () => {
    if (hapticFeedback.impactOccurred.isAvailable()) {
      hapticFeedback.impactOccurred('light');
    }
    navigate('/report');
  };

  return (
    <div className="stats-page">
      {/* Header */}
      <header className="stats-header">
        <h1 className="stats-title">Статистика</h1>
      </header>

      {/* Report link card */}
      <div className="stats-report-card" onClick={handleReportClick}>
        <div className="stats-report-icon">📊</div>
        <div className="stats-report-content">
          <div className="stats-report-title">Ежемесячный отчёт</div>
          <div className="stats-report-subtitle">Генерация Excel отчёта за месяц</div>
        </div>
        <div className="stats-report-chevron">›</div>
      </div>

      {/* Stats sections */}
      <div className="stats-sections">
        <MemberStatsSection />
        <TransferredList />
        <CompletedList />
      </div>
    </div>
  );
}
